export default __webpack_public_path__ + "static/media/alert.7087a796.png";